import mitt, { Emitter } from "mitt";
import { ILocation } from "../resources-vue/vue-interfaces/i-location";
import {
    IHomeHealthReferralExtension,
    IHomeHealthReferralOld
} from "../resources-vue/vue-interfaces/i-homehealth-referral";
import { Marker } from "../resources-vue/vue-models/marker.model";
import { ITask } from "../resources-vue/vue-interfaces/i-task";
import {
    ICallControls,
    ICallSignalNotification,
    INotification,
    IOutgoingCallProps
} from "../resources-vue/vue-interfaces/messaging-service/i-notification";
import {
    IConversationGroup,
    ICreateThreadResponse
} from "../resources-vue/vue-interfaces/messaging-service/i-family-portal";
import { ChatNavOptionsEnum } from "../enums/ChatNavOptionsEnum";

type Events = {
    "app:location:success": ILocation;
    "app:agency:loaded": void;
    addressChangedforPrimary: IHomeHealthReferralExtension | IHomeHealthReferralOld;
    "marker:created": Marker;
    "marker:task:changed": ITask;
    "marker:info:close": number;
    "app:zip:changed": string;
    "app:zip:canceled": boolean;
    replaceRouterURL: boolean;
    hasPlannertaskList: boolean;
    "message:new": any;
    "convertToPal:requestNoteId": void;
    highlightPatientNameMarker: any;
    highlightPatientLocationMarker: any;
    highlightEmployeeMarker: any;
    selectedVisitForNearbyEmp: object;

    // Axxess connect emits
    dialogOpened: boolean;
    joinMeeting: ICallSignalNotification;
    jitsiMessage: INotification;
    markCallAttendanceForUser: void;
    updateActiveChatNav: ChatNavOptionsEnum;
    agencyNavOpened: boolean;
    updateCallLogsAfterDelete: string;
    retrySuccessful: boolean;
    outgoingCallNotification: IOutgoingCallProps;
    updateCallControls: ICallControls;
    retryCall: void;
    endCurrentCall: void;
    startJitiCall: { roomId: string; isRetryCall: boolean; isFamilyPortalCall?: boolean };
    navigateToRepliedMsg: string;
    updateDisableCallBtn: boolean;
    convWrapperLoader: boolean;
    hoverOpen: string;
    updateUserStatus: any; // updates user status in plannerLevelTwo
    scrollToBottom: void;

    // Meeting Calendar emits
    updateMeetingCalendar: any;

    // Family Portal emits
    createThread: ICreateThreadResponse;
    updateNewConversation: boolean;
    conversationRead: IConversationGroup;
    callSummaryReset: any;
};

const emitter: Emitter<Events> = mitt<Events>();

export default emitter;
